import { useCallback } from 'react';

export function useExports() {
    const exportCsv = useCallback(async (startDate, endDate) => {
        try {
            const token = localStorage.getItem('jwtToken');
            const params = `startDate=${encodeURIComponent(startDate || '')}&endDate=${encodeURIComponent(endDate || '')}`;
            const response = await fetch(`/api/bulk/csv?${params}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'text/csv'
                },
            });
            if (!response.ok) {
                throw new Error(`Failed to export CSV: ${response.status}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const s = startDate ? startDate : 'all';
            const e = endDate ? endDate : 'all';
            a.download = `invoices_${s}_to_${e}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting CSV:', error);
        }
    }, []);

    const exportExcel = useCallback(async (startDate, endDate) => {
        try {
            const token = localStorage.getItem('jwtToken');
            const params = `startDate=${encodeURIComponent(startDate || '')}&endDate=${encodeURIComponent(endDate || '')}`;
            const response = await fetch(`/api/bulk/xlsx?${params}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
            });
            if (!response.ok) {
                throw new Error(`Failed to export Excel: ${response.status}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const s = startDate ? startDate : 'all';
            const e = endDate ? endDate : 'all';
            a.download = `invoices_${s}_to_${e}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Excel:', error);
        }
    }, []);

    const exportXml = useCallback(async (startDate, endDate) => {
        try {
            const token = localStorage.getItem('jwtToken');
            const params = `startDate=${encodeURIComponent(startDate || '')}&endDate=${encodeURIComponent(endDate || '')}`;
            const response = await fetch(`/api/bulk/xml?${params}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/xml'
                },
            });
            if (!response.ok) {
                // If it's a 400 Bad Request, we should perhaps extract the error message
                const errorText = await response.text();
                throw new Error(`Failed to export XML: ${response.status} - ${errorText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const s = startDate ? startDate : 'all';
            const e = endDate ? endDate : 'all';
            a.download = `invoices_${s}_to_${e}.xml`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting XML:', error);
            alert(`Възникна грешка при експортиране в XML: ${error.message}`);
        }
    }, []);

    return { exportCsv, exportExcel, exportXml };
}
